export default __webpack_public_path__ + "media/Hero_Mobile.6b79bbff6a415e206719b8350f95f383.svg";